import { useContainer } from "features/container/Feature";
import { useEditor } from "features/editor/Feature";

import { VersionDetails } from "./VersionDetails";

export const ContainerVersionDetails: React.FC = () => {
  const project = useEditor();
  const [container] = useContainer();

  return (
    <VersionDetails
      versions={[
        ["Sandbox", project.id],
        ["Node", undefined], // TODO: send node version from pitcherManager
        [
          "Pitcher",
          container.state === "READY" ? container.versions.pitcher : undefined,
        ],
        [
          "Manager",
          container.state === "READY"
            ? container.versions.pitcherManager
            : undefined,
        ],
        [
          "Cluster",
          container.state === "READY" ? container.cluster : undefined,
        ],
      ]}
    />
  );
};
